import React from 'react'
import { Card, type CardProps } from '@mantine/core'

export type AppCardProps = CardProps;

/**
 * Standard card container with border and consistent padding.
 * Default padding: 16px (md), can override with: xs=4px, sm=8px, md=16px, lg=24px, xl=40px
 */
export default function AppCard ({ withBorder = true, radius = 'md', padding = 'md', ...props }: AppCardProps) {
  return <Card withBorder={withBorder} radius={radius} padding={padding} {...props} />
}
